import Box from '@mui/material/Box'
import PropTypes from 'prop-types'
import React from 'react'

import ExceptionsContent from 'components/work-order/details/exceptions/ExceptionsContent'
import useExceptions from 'components/work-order/details/exceptions/useExceptions'

const WorkOrderExceptionsTab = ({ accountId, workOrderId, exceptions = [] }) => {
  const { allExceptions, currentException, isExceptionGalleryViewOpen, handleCardClick, handleGalleryClose } = useExceptions(exceptions)

  return (
    <Box p={2}>
      <ExceptionsContent
        accountId={accountId}
        allExceptions={allExceptions}
        currentException={currentException}
        handleCardClick={handleCardClick}
        handleGalleryClose={handleGalleryClose}
        isExceptionGalleryViewOpen={isExceptionGalleryViewOpen}
        workOrderId={workOrderId}
      />
    </Box>
  )
}

WorkOrderExceptionsTab.propTypes = {
  accountId: PropTypes.string.isRequired,
  workOrderId: PropTypes.string.isRequired,
  exceptions: PropTypes.array,
}

export default WorkOrderExceptionsTab
